import {
  mirrorVerticalBeamPosition,
  type VerticalBeamPosition,
} from "entities/configurator/model/layoutMeta";

export const getTaatsLocalVerticalPosition = (
  position: VerticalBeamPosition | undefined,
  shouldMirror: boolean,
): VerticalBeamPosition | undefined => {
  // DoubleTaats rotates the left leaf 180°, so both leaves use this local side.
  return shouldMirror ? mirrorVerticalBeamPosition(position) : position;
};
